import { DatePipe, NgClass, NgIf, NgSwitch, NgSwitchCase } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { WindowService } from '@progress/kendo-angular-dialog';
import { PDFSERVICE } from '../../../@theme/services/pdfgetfiles.service';
import { TypesServices } from '../../../@theme/services/typeslist.service';
import { RvCheckBoxComponent } from '../ratoms/checkbox';
import { RvDropDownComponent } from '../ratoms/dropdown';
import { RvLabelComponent } from '../ratoms/label';
import { RvMulitLineComponent } from '../ratoms/multiline';
import { RvRadioComponent } from '../ratoms/radio';
import { RvTextBoxComponent } from '../ratoms/textbox';
@Component({
    selector: 'gd-rvfield-builder',
    styleUrls: ['./test.css'],
    template: `
    <div class="form-group row" [formGroup]="form">
      <label
        *ngIf="field.label !== null; let i = index"
        [ngClass]="{
          Notfieldnull: field.label !== null,
          fieldnull: field.label === ''
        }"
        [attr.for]="field.label"
      >
        <strong class="text-danger" *ngIf="field.required">*</strong>&nbsp;{{
          field.counter
        }}. {{ field.label }}&nbsp;&nbsp;<span *ngIf="field.pdfrequired"
          ><img
            src="../../../../assets/images/pdf.gif"
            (click)="GetDisclosureForm(field.pdfPath)"
        /></span>
      </label>
      <div class="card-col" [ngSwitch]="field.type">
        <gd-rvlabel
          *ngSwitchCase="'label'"
          [field]="field"
          [form]="form"
        ></gd-rvlabel>
        <gd-rvtextbox
          *ngSwitchCase="'text'"
          [field]="field"
          [form]="form"
        ></gd-rvtextbox>
        <gd-rvmulti
          *ngSwitchCase="'multiline'"
          style="height: 100px;"
          [field]="field"
          [form]="form"
        ></gd-rvmulti>
        <gd-rvdropdown
          *ngSwitchCase="'dropdown'"
          [field]="field"
          [form]="form"
        ></gd-rvdropdown>
        <gd-rvcheckbox
          *ngSwitchCase="'checkbox'"
          [field]="field"
          [form]="form"
        ></gd-rvcheckbox>
        <gd-rvradio
          *ngSwitchCase="'radio'"
          (checkVals)="checkVal($event)"
          [field]="field"
          [form]="form"
        ></gd-rvradio>
      </div>
      <span
        *ngIf="field.modifiedBy !== null"
        style="font-size:11px; text-align:right; margin-left: 40px;"
        >{{ field.modifiedBy }}&nbsp;&nbsp;{{
          field.modifiedDate | date : 'medium'
        }}</span
      >
    </div>
  `,
    imports: [
        FormsModule,
        ReactiveFormsModule,
        NgIf,
        NgClass,
        NgSwitch,
        NgSwitchCase,
        RvLabelComponent,
        RvTextBoxComponent,
        RvMulitLineComponent,
        RvDropDownComponent,
        RvCheckBoxComponent,
        RvRadioComponent,
        DatePipe,
    ]
})
export class RvFieldBuilderComponent {
  @Input() field: any
  @Input() form: any
  @Input() cnt: any
  @Output() checkValsues = new EventEmitter()
  @Output() pushupone = new EventEmitter()
  @Input() clientId: number
  public ctnn = 0
  public listStates: Array<any> = []
  public value = new Date()
  public reptextval: any
  public opened = false
  get isValid() {
    return this.form.controls[this.field.name].valid
  }
  get isDirty() {
    return this.form.controls[this.field.name].dirty
  }
  public windowTop = 500
  public windowLeft = 50
  public offset = 300
  public left = this.offset
  public top = this.offset
  public width = 400
  public height = 350
  constructor(
    private getser: PDFSERVICE,
    private typ: TypesServices,
    private windowService: WindowService,
  ) {
    localStorage.setItem('repalert', 'false')
  }
  public close() {
    this.opened = false
  }
  public onEnd() {
    const windowWidth = window.innerWidth
    const windowHeight = window.innerHeight
    const positionTop = windowHeight - this.height - this.offset
    const positionLeft = windowWidth - this.width - this.offset

    if (this.top < this.offset) {
      this.top = this.offset
    }

    if (this.top > positionTop) {
      this.top = positionTop
    }

    if (this.left < this.offset) {
      this.left = this.offset
    }

    if (this.left > positionLeft) {
      this.left = positionLeft
    }
  }
}
